import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { ChatService } from '../../services/chat.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MessageTimestampComponent } from '../common/message-timestamp/message-timestamp.component';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-dynamic-alert',
  templateUrl: './dynamic-alert.component.html',
  styleUrls: ['./dynamic-alert.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MessageTimestampComponent,
    MatCardModule,
    MatIconModule,
  ],
})
export class DynamicAlertComponent implements OnInit {
  @Input() input: any;
  @Input() isRead: boolean = false;
  @Input() lastMessage!: boolean;
  @Output() action: EventEmitter<any> = new EventEmitter<any>();

  config: any;
  messageText: string = '';
  previousConversationId = 0;
  buttonItems: any[] = [];
  iconType: string = '';

  constructor(private chatService: ChatService) {}

  get configs() {
    return this.chatService.configs;
  }

  ngOnInit() {
    this.config = this.input?.config;
    this.messageText = this.input?.message_text;
    this.previousConversationId =
    this.input?.config?.previous_conversation_id || 0;
    this.buttonItems = this.input?.config?.button_items || [];
    this.iconType = this.input?.config?.icon_type === 'Error'? 'Cancel' : this.input?.config?.icon_type;
  }

  getMessageStyles() {
    return {
      'background-color': this.configs?.colors?.bot_message_background,
      color: this.configs?.colors?.bot_message_text,
      border: `1px solid ${this.configs?.colors?.bot_message_border}`,
      'font-family': this.configs?.fonts?.default_font,
    };
  }

getIconClass(): string {
  switch (this.iconType) {
    case 'Cancel':
      return 'icon-error';
    case 'Info':
      return 'icon-info';
    case 'Warning':
      return 'icon-warning';
    case 'Simple':
      return 'simple-alert';
    default:
      return '';
  }
}

  closeDialog() {
    this.lastMessage = false;
  }

  onButtonClick(button: any) {
    if (this.previousConversationId > 0 && button.id.includes('562-2-1')) {
      this.action.emit({
        type: 'load_previous_conversation',
        button_id: `${button.id}`,
        message_text: button.label,
        option: button,
        label: button.label,
        previousConversationId: this.previousConversationId,
      });
      return;
    }
    this.action.emit({
      type: 'Response',
      button_id: `${button.id}`,
      message_text: button.label,
      option: button,
      label: button.label,
    });
  }
}
